import { NOT_AUTHORIZED, NOT_AUTHORIZED_STATUS } from "../utils/constants";
import fetchRetry from "../utils/fetchRetry";
import { getPuConfigUrl } from "../utils/urlUtils";

export const createCookies = (authToken: string) => {
  return new Promise<void>((resolve, reject) => {
    if (!window.GameEnvironment.config.require_cookies) {
      resolve();
      return;
    }

    var cookie_url = getPuConfigUrl() + "/cookies";
    const headers = new Headers();
    headers.append("Authorization", authToken);
    var myInit = {
      method: "GET",
      headers: headers,
    };
    fetchRetry(cookie_url, myInit)
      .then((resp) => {
        if (NOT_AUTHORIZED_STATUS.includes(resp.status)) {
          reject(NOT_AUTHORIZED);
        } else if (resp.status >= 300) {
          reject();
        } else {
          resp.json().then(function (data) {
            var cookies = data.cookies;
            for (var ck of cookies) {
              document.cookie = ck;
            }
            resolve();
          });
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
